import styled from 'styled-components';

export const Menu = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Loading = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
